/* eslint-disable */

import jQuery from 'jquery';

(function($) {
  $.fn.serializeObject = function() {
    var o = {};
    var a = this.serializeArray().filter(field => field.value.length > 0);

    $.each(a, function() {
      if (o[this.name] !== undefined) {
        if (!o[this.name].push) {
          o[this.name] = [o[this.name]];
        }
        o[this.name].push(this.value || '');
      } else {
        o[this.name] = this.value || '';
      }
    });

    this.find('input[type="checkbox"]:not(:checked)').each(function() {
      if (o[this.name] !== undefined) {
        if (!o[this.name].push) {
          o[this.name] = [o[this.name]];
        }
        o[this.name].push('off');
      } else {
        o[this.name] = 'off';
      }
    });

    return o;
  };
})(jQuery);



// WEBPACK FOOTER //
// ./src/plugins/forms.js